import type { FC } from 'react';
import { useContext } from 'react';
import { PapiCorePackageV3 } from '@wix/da-papi-types';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import CoreRecurringPriceAndCycle from '../../../../CoreRecurringPriceAndCycle';

import s from './PackageSublabel.scss';

interface Props {
  corePackage: PapiCorePackageV3;
  showDiscountedPrice: boolean;
}

const PackageSublabel: FC<Props> = ({
  showDiscountedPrice,
  corePackage,
}) => {
  const isMobile = useContext(MobileContext);

  if (!isMobile) {
    return null;
  }

  const isMonthly = corePackage['interval'] === 'month';
  const hasDiscount =
    showDiscountedPrice && !!corePackage.monthlyPriceBeforeDiscount;

  // Determine the price display mode based on package type and discount availability
  const getPriceDisplayMode = () => {
    if (!hasDiscount) return 'original';
    if (isMonthly) return 'both'; // Show original (strikethrough) + discounted for monthly
    return 'discounted'; // Show only discounted for yearly
  };

  return (
    <div className={s['root']}>
      {/* larger price with discount */}
      <CoreRecurringPriceAndCycle
        className={s['bigger-font']}
        corePackage={corePackage}
        priceStyle={'extra-bold'}
        priceDisplayMode={getPriceDisplayMode()}
        reverseOrder={hasDiscount && isMonthly}
      />
      {/* a smaller, strikethrough version of what they -would- have payed w/o discount */}
      {hasDiscount && !isMonthly && (
        <CoreRecurringPriceAndCycle
          className={s['before-discount']}
          corePackage={corePackage}
          priceDisplayMode={'original'}
        />
      )}
    </div>
  );
};
PackageSublabel.displayName = 'PackageSublabel';

export default PackageSublabel;
